// @flow
import WebSocketClient from 'speed-js-core';
import { PBX_WS_COMMAND } from 'esm-web-pro/containers/panels/calling/PBXWSController';
import { workingTabPBXActionTypes, WS_DISPATCH_ACTION } from './constants';


const middleware = (ws: WebSocketClient) => (store) => (next) => (action) => {
    if (Object.hasOwnProperty.call(workingTabPBXActionTypes, action.type)) {
        // Send the websocket message with the action as payload
        ws.send(PBX_WS_COMMAND, {
            action: 'dispatch_action',
            payload: {
                ...action,
            },
        });
        return next(action);
    }

    if (action.type === WS_DISPATCH_ACTION) {
        // The payload of this action should be another action which updates the redux state
        const reduxUpdateAction = { ...action.payload.payload };
        return next(reduxUpdateAction);
    }

    return next(action);
};

export default middleware;
